module.exports = "<div class=\"page-header\">\r\n  <h1>Последние новости</h1>\r\n</div>\r\n<div class=\"row\">    \r\n  <div class=\"col-xs-12 col-sm-6 col-md-4\" *ngFor=\"let item of news\">\r\n    <h1 [innerHtml]=\"item.Title\"></h1>\r\n    <div [innerHtml]=\"item.Content\" class=\"small-news-view\"></div>\r\n    <p class=\"m-t-sm pull-right\"><a class=\"btn btn-primary\" uiSref=\"news.detail\" [uiParams]=\"{ id: item.id }\" role=\"button\">Подробнее</a></p>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app-main/app-main.component.html
// module id = 830
// module chunks = 1